import React from "react";
import { useTranslation } from "react-i18next";

const DisclaimerPaymentFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="fw-400 font-xssss disclaimerPaymentFooter">
      <a href="/terms-conditions" target="_blank" className="text-grey-600">
        {t("terms.title")}
      </a>

      <a href="/terms-user" className="text-grey-600">
        {t("terms.termsFans")}
      </a>
      <a href="/refund-policy" target="_blank" className="text-grey-600">
        {t("terms.refundpolicy")}
      </a>
      <a href="/terms-user-creator" target="_blank" className="text-grey-600">
        {t("terms.termsFansCreators")}
      </a>
    </div>
  );
};

export default DisclaimerPaymentFooter;
